import { Routes } from '@angular/router';
import { authGuard } from '@c3library/guards/auth-guard';

export const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'dashboard',
  },
  {
    path: 'login',
    loadChildren: () => import('@c3library/login/login-module').then((m) => m.LoginModule),
  },
  {
    path: 'forgot-password',
    loadComponent: () =>
      import('@c3library/login/username-login/forgot-password/forgot-password').then(
        (m) => m.ForgotPassword,
      ),
  },
  {
    path: 'reset-password/:guid',
    loadComponent: () =>
      import('@c3library/login/username-login/reset-password/reset-password').then(
        (m) => m.ResetPassword,
      ),
  },
  {
    path: 'create-password/:guid',
    loadComponent: () =>
      import('@c3library/login/username-login/create-password/create-password').then(
        (m) => m.CreatePassword,
      ),
  },
  {
    path: '',
    canActivate: [authGuard],
    loadChildren: () => import('./layout/layout-module').then((m) => m.LayoutModule),
  },

  // {
  //     path: '', redirectTo: 'login', pathMatch: 'full',
  // },
  // {
  //     path: '',
  //             loadChildren: () =>
  //         import('./shared/layout/layout-module').then(m => m.LayoutModule)
  // },
  // {
  //     path: 'login',
  //     loadChildren: () =>
  //         import('./login/login-module').then(m => m.LoginModule)
  // },
  // {
  //     path: 'blocks',
  //     loadChildren: () =>
  //         import('./blocks/blocks-module').then(m => m.BlocksModule)
  // }
];
